module.exports = __webpack_public_path__ + "static/thesisSwedish-fe47634fb31b2d5bf3838b4a238282e6.pdf";